import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Toaster } from 'react-hot-toast'
import './index.css'
import App from './App.tsx'

// Simple App component with basic navigation - COMMENTED OUT, USING REAL APP.TSX
/*function App() {
  const [currentPage, setCurrentPage] = React.useState('dashboard')
  const [states, setStates] = React.useState([])
  const [cities, setCities] = React.useState([])
  const [selectedState, setSelectedState] = React.useState('')

  // Load states on component mount
  React.useEffect(() => {
    fetch('http://localhost:8000/states')
      .then((response) => response.json())
      .then((data) => setStates(data))
      .catch((error) => console.error('Error loading states:', error))
  }, [])

  // Load cities when state changes
  React.useEffect(() => {
    if (selectedState) {
      fetch(`http://localhost:8000/cities/${selectedState}`)
        .then((response) => response.json())
        .then((data) => setCities(data))
        .catch((error) => console.error('Error loading cities:', error))
    }
  }, [selectedState])

  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return (
          <div className='p-6'>
            <h1 className='text-3xl font-bold text-gray-900 mb-6'>
              VaporScraper Dashboard
            </h1>
            <div className='grid grid-cols-1 md:grid-cols-3 gap-6 mb-8'>
              <div className='bg-white p-6 rounded-lg shadow'>
                <h3 className='text-lg font-semibold text-gray-900'>
                  Total Jobs
                </h3>
                <p className='text-3xl font-bold text-blue-600'>0</p>
              </div>
              <div className='bg-white p-6 rounded-lg shadow'>
                <h3 className='text-lg font-semibold text-gray-900'>
                  Total Stores
                </h3>
                <p className='text-3xl font-bold text-green-600'>0</p>
              </div>
              <div className='bg-white p-6 rounded-lg shadow'>
                <h3 className='text-lg font-semibold text-gray-900'>
                  Active Jobs
                </h3>
                <p className='text-3xl font-bold text-yellow-600'>0</p>
              </div>
            </div>
            <div className='bg-white p-6 rounded-lg shadow'>
              <h3 className='text-lg font-semibold text-gray-900 mb-4'>
                Quick Actions
              </h3>
              <div className='space-x-4'>
                <button
                  onClick={() => setCurrentPage('create-job')}
                  className='bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700'
                >
                  Create New Job
                </button>
                <button
                  onClick={() => setCurrentPage('settings')}
                  className='bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700'
                >
                  Settings
                </button>
              </div>
            </div>
          </div>
        )
      case 'create-job':
        return (
          <div className='p-6'>
            <h1 className='text-3xl font-bold text-gray-900 mb-6'>
              Create Scraping Job
            </h1>
            <div className='bg-white p-6 rounded-lg shadow'>
              <form className='space-y-4'>
                <div>
                  <label className='block text-sm font-medium text-gray-700'>
                    State
                  </label>
                  <select
                    className='mt-1 block w-full border border-gray-300 rounded-md px-3 py-2'
                    value={selectedState}
                    onChange={(e) => setSelectedState(e.target.value)}
                  >
                    <option value=''>Select State</option>
                    {states.map((state: { code: string; name: string }) => (
                      <option key={state.code} value={state.code}>
                        {state.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className='block text-sm font-medium text-gray-700'>
                    Cities
                  </label>
                  <select
                    className='mt-1 block w-full border border-gray-300 rounded-md px-3 py-2'
                    disabled={!selectedState}
                  >
                    <option value=''>Select City</option>
                    {cities.map((city: { name: string }) => (
                      <option key={city.name} value={city.name}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className='block text-sm font-medium text-gray-700'>
                    Keywords
                  </label>
                  <input
                    type='text'
                    placeholder='vape, smoke shop, e-cig'
                    className='mt-1 block w-full border border-gray-300 rounded-md px-3 py-2'
                  />
                </div>
                <button
                  type='button'
                  onClick={() => setCurrentPage('dashboard')}
                  className='bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700'
                >
                  Create Job
                </button>
              </form>
            </div>
          </div>
        )
      case 'settings':
        return (
          <div className='p-6'>
            <h1 className='text-3xl font-bold text-gray-900 mb-6'>Settings</h1>
            <div className='bg-white p-6 rounded-lg shadow'>
              <div className='space-y-4'>
                <div>
                  <label className='block text-sm font-medium text-gray-700'>
                    Google Places API Key
                  </label>
                  <input
                    type='text'
                    value='AIzaSyDWwUTWQ9dFMwX1ZhGJudpmDlh93Y6FgVk'
                    className='mt-1 block w-full border border-gray-300 rounded-md px-3 py-2'
                    readOnly
                  />
                </div>
                <div>
                  <label className='block text-sm font-medium text-gray-700'>
                    RapidAPI Key
                  </label>
                  <input
                    type='text'
                    value='2fd697f3e1msh0497881bc6c07b4p1a62fbjsn57ffa7b41ab6'
                    className='mt-1 block w-full border border-gray-300 rounded-md px-3 py-2'
                    readOnly
                  />
                </div>
                <button
                  onClick={() => setCurrentPage('dashboard')}
                  className='bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700'
                >
                  Back to Dashboard
                </button>
              </div>
            </div>
          </div>
        )
      default:
        return <div>Page not found</div>
    }
  }

  return (
    <div className='min-h-screen bg-gray-100'>
      <nav className='bg-white shadow'>
        <div className='px-6 py-4'>
          <div className='flex items-center justify-between'>
            <h1 className='text-xl font-bold text-gray-900'>VaporScraper</h1>
            <div className='space-x-4'>
              <button
                onClick={() => setCurrentPage('dashboard')}
                className={`px-3 py-2 rounded ${
                  currentPage === 'dashboard'
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                Dashboard
              </button>
              <button
                onClick={() => setCurrentPage('create-job')}
                className={`px-3 py-2 rounded ${
                  currentPage === 'create-job'
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                Create Job
              </button>
              <button
                onClick={() => setCurrentPage('settings')}
                className={`px-3 py-2 rounded ${
                  currentPage === 'settings'
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                Settings
              </button>
            </div>
          </div>
        </div>
      </nav>
      <main>{renderPage()}</main>
    </div>
  )
}*/

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster
        position='top-right'
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#10B981',
              secondary: '#fff',
            },
          },
          error: {
            duration: 5000,
            iconTheme: {
              primary: '#EF4444',
              secondary: '#fff',
            },
          },
        }}
      />
    </QueryClientProvider>
  </React.StrictMode>
)
